import React, { FC, useEffect, useState } from "react";

import { SiteAlertView } from "../components/SiteAlertView";
import { StatusIncident, UnresolvedStatusResponse } from "../models";

export const SiteAlertContainer: FC = () => {

    const [currentIncident, setIncident] = useState<StatusIncident>();
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        const url = window?.xaStudioConfig?.statusUrl // __STATUS_URL__;

        const fetchData = async () => {
            try {
                const response = await fetch(url);
                const json: UnresolvedStatusResponse = await response.json();
                if (json.incidents.length > 0) {
                    setIncident(json.incidents[0]);
                    setShow(true);
                }
            } catch (error) {
                console.log("error", error);
            }
        };

        fetchData();
    }, []);

    if (show) {
        return <SiteAlertView onDismiss={setShow.bind(undefined, false)} incident={currentIncident} />;
    } else {
        return <></>;
    }
};